import { useContext } from "react"

import { FormatterContext } from "#Contexts/FormatterContext"
import NumberHelpers from "#Utils/number_helpers"

import FileSizeCalculator from "./FileSizeCalculator"

type FileSizeFormat = "bit" | "byte" | "kilobit" | "kilobyte" | "megabyte"

type FormattedFileSizeProps = {
  value: number
  format?: FileSizeFormat
  precision?: number
}

const FormattedFileSize = ({
  value,
  format = "megabyte",
  precision = 2,
}: FormattedFileSizeProps) => {
  const formatter = useContext(FormatterContext)
  const separator = formatter.number === "DC" ? "," : "."
  const delimiter = formatter.number === "DC" ? "." : ","

  // The size in the agent is in megabytes, convert it back
  // to bytes for the formatter we're using.
  const formattedSize = (() => {
    switch (format) {
      case "bit":
        return value / 8
      case "byte":
        return value
      case "kilobit":
        return (value / 8) * 1024
      case "kilobyte":
        return value * 1024
      default:
        return FileSizeCalculator.mebibytesToBytes(value)
    }
  })()

  const formattedNumber = NumberHelpers.number_to_human_size(formattedSize, {
    separator,
    delimiter,
    strip_empty_fractional_parts: true,
    strip_insignificant_zeros: true,
    precision,
    significant: false,
  })

  return <span>{formattedNumber}</span>
}

export default FormattedFileSize
